document.querySelectorAll('.accordion-title-container').forEach(item => {
    item.addEventListener('click', (event) => {

        const BRIEF_CONTENT = event.target.nextElementSibling;
        const ACCORDION_TITLE = event.target;

        if (BRIEF_CONTENT.classList.contains("accordion-open")) {
            BRIEF_CONTENT.classList.remove("accordion-open");
            ACCORDION_TITLE.classList.remove("accordion-open");
            BRIEF_CONTENT.setAttribute('aria-expanded', "false");
        } else {
            BRIEF_CONTENT.classList.add("accordion-open");
            ACCORDION_TITLE.classList.add("accordion-open");
            BRIEF_CONTENT.setAttribute('aria-expanded', "true");
        }
    })
})


document.querySelectorAll('.accordion-container').forEach(item => {
    item.addEventListener('click', (event) => {

        const BRIEF_CONTENT = event.target.childNodes[1].nextElementSibling;
        const ACCORDION_TITLE = event.target;

        if (BRIEF_CONTENT.classList.contains("accordion-open")) {
            BRIEF_CONTENT.classList.remove("accordion-open");
            ACCORDION_TITLE.classList.remove("accordion-open");
            BRIEF_CONTENT.setAttribute('aria-expanded', "false");
        } else {
            BRIEF_CONTENT.classList.add("accordion-open");
            ACCORDION_TITLE.classList.add("accordion-open");
            BRIEF_CONTENT.setAttribute('aria-expanded', "true");
        }
    })
})

document.querySelectorAll('.accordion-arrow').forEach(item => {
    item.addEventListener('click', (event) => {

        const BRIEF_CONTENT = event.target.parentElement.nextElementSibling;
        const ACCORDION_TITLE = event.target;

        if (BRIEF_CONTENT.classList.contains("accordion-open")) {
            BRIEF_CONTENT.classList.remove("accordion-open");
            ACCORDION_TITLE.classList.remove("accordion-open");
            BRIEF_CONTENT.setAttribute('aria-expanded', "false");
        } else {
            BRIEF_CONTENT.classList.add("accordion-open");
            ACCORDION_TITLE.classList.add("accordion-open");
            BRIEF_CONTENT.setAttribute('aria-expanded', "true");
        }
    })
})




